export default "__VITE_ASSET__sz2cKZlU__"